import styled from 'styled-components/macro';

export const ScrollWrapper = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
  overflow-y: auto;
  overscroll-behavior-y: none;

  ::-webkit-scrollbar {
    width: 12px;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: inherit;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e4e8ee;
    border: 4px solid #ffffff;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #9da6b4;
  }
`;

export const EmptyList = styled.div`
  padding: 10px 12px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #1f2939;
`;
